import imageCompression from 'browser-image-compression';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo_blade.png';
import iconeAdicionarFoto from '../icone_adicionar_foto.png';
import { auth, db, storage } from '../services/firebase';
import { doc, getDoc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { performLogout } from '../hooks/useSessionPersistence';

async function uploadFoto(arquivo, caminho) {
  const options = { maxSizeMB: 0.5, maxWidthOrHeight: 800, useWebWorker: true };
  const comprimido = await imageCompression(arquivo, options);
  const storageRef = ref(storage, caminho);
  await uploadBytes(storageRef, comprimido);
  return await getDownloadURL(storageRef);
}

function PerfilCliente({ onVoltar, onLogout }) {
  const [cliente, setCliente] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [aba, setAba] = useState('perfil');
  const [editando, setEditando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [menuFotoAberto, setMenuFotoAberto] = useState(false);
  const [salvandoFoto, setSalvandoFoto] = useState(false);
  const [sucesso, setSucesso] = useState('');
  const [erro, setErro] = useState('');
  const [historico, setHistorico] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);

  // Campos editáveis
  const [nomeEdit, setNomeEdit] = useState('');
  const [emailEdit, setEmailEdit] = useState('');
  const [nascimentoEdit, setNascimentoEdit] = useState('');

  const inputArquivoRef = useRef(null);
  const inputCameraRef = useRef(null);

  useEffect(() => {
    async function buscarDados() {
      try {
        const user = auth.currentUser;
        if (user) {
          const snap = await getDoc(doc(db, 'clientes', user.uid));
          if (snap.exists()) {
            const dados = snap.data();
            setCliente(dados);
            setNomeEdit(dados.nome || '');
            setEmailEdit(dados.email || '');
            setNascimentoEdit(dados.nascimento || '');
          } else {
            const dadosBase = {
              nome: user.displayName || '',
              telefone: user.phoneNumber || '',
              criadoEm: new Date().toISOString(),
            };
            setCliente(dadosBase);
            setNomeEdit(dadosBase.nome);
          }
        }
      } catch (e) {
        console.error(e);
      }
      setCarregando(false);
    }
    buscarDados();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (aba !== 'historico') return;
    async function buscarHistorico() {
      setCarregandoHistorico(true);
      try {
        const user = auth.currentUser;
        if (!user) return;
        const snap = await getDocs(query(
          collection(db, 'agendamentos'),
          where('clienteId', '==', user.uid)
        ));
        const lista = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(a => a.status !== 'bloqueado')
          .sort((a, b) => {
            // Ordena do mais recente para o mais antigo usando criadoEm
            return (b.criadoEm || '').localeCompare(a.criadoEm || '');
          });
        setHistorico(lista);
      } catch (e) {
        console.error(e);
      }
      setCarregandoHistorico(false);
    }
    buscarHistorico();
  }, [aba]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleNovaFoto(arquivo) {
    if (!arquivo) return;
    setSalvandoFoto(true);
    try {
      const user = auth.currentUser;
      const fotoUrl = await uploadFoto(arquivo, `clientes/${user.uid}/foto_perfil`);
      await setDoc(doc(db, 'clientes', user.uid), { foto: fotoUrl }, { merge: true });
      setCliente(prev => ({ ...prev, foto: fotoUrl }));
    } catch (e) {
      console.error(e);
    }
    setSalvandoFoto(false);
    setMenuFotoAberto(false);
  }

  async function salvarPerfil() {
    if (!nomeEdit.trim()) { setErro('Nome é obrigatório'); return; }
    setSalvando(true);
    setErro('');
    try {
      const user = auth.currentUser;
      const dados = {
        nome: nomeEdit.trim(),
        email: emailEdit.trim(),
        nascimento: nascimentoEdit,
      };
      await setDoc(doc(db, 'clientes', user.uid), dados, { merge: true });
      setCliente(prev => ({ ...prev, ...dados }));
      setEditando(false);
      setSucesso('Perfil atualizado!');
      setTimeout(() => setSucesso(''), 3000);
    } catch (e) {
      setErro('Erro ao salvar. Tente novamente.');
    }
    setSalvando(false);
  }

  async function handleLogout() {
    try {
      await performLogout();
      onLogout();
    } catch (e) {
      onLogout();
    }
  }

  const inputStyle = {
    width: '100%', padding: '12px', borderRadius: '10px',
    border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
    color: '#e8e8e8', fontSize: '14px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Arial, sans-serif'
  };
  const labelStyle = {
    fontSize: '10px', color: '#9c9c9c', letterSpacing: '1px',
    textTransform: 'uppercase', display: 'block', marginBottom: '5px'
  };

  if (carregando) {
    return (
      <div style={{ backgroundColor: '#111111', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#8f8f8f', fontSize: '13px' }}>Carregando...</p>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8' }}>

      {/* Menu foto */}
      {menuFotoAberto && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 999
        }} onClick={() => setMenuFotoAberto(false)}>
          <div style={{
            width: '100%', maxWidth: '480px', backgroundColor: '#181818',
            borderRadius: '16px 16px 0 0', padding: '24px', border: '0.5px solid #252525'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ width: '40px', height: '4px', backgroundColor: '#333', borderRadius: '2px', margin: '0 auto 20px' }} />
            <p style={{ fontSize: '13px', color: '#8f8f8f', textAlign: 'center', marginBottom: '16px' }}>Foto de perfil</p>
            <button onClick={() => { setMenuFotoAberto(false); setTimeout(() => inputArquivoRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', marginBottom: '10px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📁 Escolher da galeria
            </button>
            <button onClick={() => { setMenuFotoAberto(false); setTimeout(() => inputCameraRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📸 Tirar foto
            </button>
          </div>
        </div>
      )}

      <input ref={inputArquivoRef} type="file" accept="image/*" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && handleNovaFoto(e.target.files[0])} />
      <input ref={inputCameraRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && handleNovaFoto(e.target.files[0])} />

      {/* Cabeçalho */}
      <div style={{ padding: '16px 20px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span onClick={onVoltar} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
        <img src={logo} alt="BLADE" style={{ height: '28px', cursor: 'pointer' }} onClick={onVoltar} />
        <span style={{ width: '22px' }} />
      </div>

      {/* Avatar e nome */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '28px 20px 16px' }}>
        <div onClick={() => setMenuFotoAberto(true)} style={{ position: 'relative', cursor: 'pointer', marginBottom: '12px' }}>
          <div style={{
            width: '88px', height: '88px', borderRadius: '50%',
            backgroundColor: '#1a2a1a', border: '2px solid #2d4a2d',
            overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            {salvandoFoto ? (
              <span style={{ fontSize: '11px', color: '#8f8f8f' }}>...</span>
            ) : cliente?.foto ? (
              <img src={cliente.foto} alt="perfil" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display = 'none'} />
            ) : (
              <img src={iconeAdicionarFoto} alt="adicionar foto" style={{ width: '44px', height: '44px', opacity: 0.4, filter: 'invert(1)' }} />
            )}
          </div>
          <div style={{
            position: 'absolute', bottom: 0, right: 0,
            width: '24px', height: '24px', borderRadius: '50%',
            backgroundColor: '#2d4a2d', border: '2px solid #111111',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px'
          }}>✏️</div>
        </div>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#e8e8e8', marginBottom: '2px' }}>
          {cliente?.nome || 'Cliente'}
        </div>
        <div style={{ fontSize: '13px', color: '#8f8f8f' }}>{cliente?.telefone || ''}</div>
        {sucesso && <p style={{ fontSize: '12px', color: '#7bc47b', marginTop: '8px' }}>{sucesso}</p>}
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', gap: '8px', padding: '0 20px 16px' }}>
        {['perfil', 'historico'].map(a => (
          <button key={a} onClick={() => { setAba(a); setEditando(false); }} style={{
            flex: 1, padding: '8px',
            backgroundColor: aba === a ? '#2d4a2d' : '#181818',
            color: aba === a ? '#7bc47b' : '#555',
            border: `0.5px solid ${aba === a ? '#3d6b3d' : '#252525'}`,
            borderRadius: '20px', cursor: 'pointer',
            fontSize: '12px', fontFamily: 'Arial, sans-serif'
          }}>
            {a === 'perfil' ? 'Meu Perfil' : 'Histórico'}
          </button>
        ))}
      </div>

      {aba === 'perfil' ? (
        <div style={{ padding: '0 20px 32px' }}>
          {!editando ? (
            <>
              {/* Modo visualização */}
              <div style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '12px', padding: '16px', marginBottom: '12px' }}>
                <div style={{ fontSize: '10px', color: '#8f8f8f', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>
                  Dados cadastrais
                </div>
                {[
                  { label: 'Nome',              valor: cliente?.nome },
                  { label: 'Telefone',           valor: cliente?.telefone },
                  { label: 'Email',              valor: cliente?.email || '—' },
                  { label: 'Data de nascimento', valor: cliente?.nascimento ? new Date(cliente.nascimento + 'T12:00:00').toLocaleDateString('pt-BR') : '—' },
                  { label: 'Membro desde',       valor: cliente?.criadoEm ? new Date(cliente.criadoEm).toLocaleDateString('pt-BR') : '—' },
                ].map((item, i, arr) => (
                  <div key={i} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '8px 0',
                    borderBottom: i < arr.length - 1 ? '0.5px solid #1e1e1e' : 'none'
                  }}>
                    <span style={{ fontSize: '12px', color: '#8f8f8f' }}>{item.label}</span>
                    <span style={{ fontSize: '13px', color: '#ccc' }}>{item.valor || '—'}</span>
                  </div>
                ))}
              </div>

              <button onClick={() => setEditando(true)} style={{
                width: '100%', backgroundColor: 'transparent',
                color: '#7bc47b', border: '0.5px solid #2d4a2d',
                borderRadius: '12px', padding: '14px', fontSize: '14px',
                cursor: 'pointer', fontFamily: 'Arial, sans-serif', marginBottom: '10px'
              }}>
                Editar perfil
              </button>

              <button onClick={handleLogout} style={{
                width: '100%', backgroundColor: 'transparent',
                color: '#e24b4a', border: '0.5px solid #4a1a1a',
                borderRadius: '12px', padding: '14px', fontSize: '14px',
                cursor: 'pointer', fontFamily: 'Arial, sans-serif'
              }}>
                Sair da conta
              </button>
            </>
          ) : (
            <>
              {/* Modo edição */}
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Nome completo *</label>
                <input type="text" value={nomeEdit} onChange={e => setNomeEdit(e.target.value)} style={inputStyle} />
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Email (opcional)</label>
                <input type="email" value={emailEdit} onChange={e => setEmailEdit(e.target.value)} placeholder="seu@email.com" style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={labelStyle}>Data de nascimento (opcional)</label>
                <input type="date" value={nascimentoEdit} onChange={e => setNascimentoEdit(e.target.value)}
                  style={{ ...inputStyle, colorScheme: 'dark' }} />
              </div>

              {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '10px' }}>{erro}</p>}

              <button onClick={salvarPerfil} disabled={salvando} style={{
                width: '100%', backgroundColor: salvando ? '#1a2a1a' : '#2d4a2d',
                color: '#7bc47b', border: 'none', borderRadius: '12px',
                padding: '14px', fontSize: '14px', fontWeight: '600',
                cursor: salvando ? 'default' : 'pointer',
                fontFamily: 'Arial, sans-serif', marginBottom: '10px'
              }}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
              <button onClick={() => { setEditando(false); setErro(''); }} style={{
                width: '100%', backgroundColor: 'transparent', color: '#8f8f8f',
                border: '0.5px solid #252525', borderRadius: '12px',
                padding: '14px', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif'
              }}>
                Cancelar
              </button>
            </>
          )}
        </div>
      ) : (
        <div style={{ padding: '0 20px 24px' }}>
          {carregandoHistorico ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#8f8f8f', fontSize: '13px' }}>Carregando...</div>
          ) : historico.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#8f8f8f', fontSize: '13px' }}>
              Nenhum agendamento encontrado.
            </div>
          ) : (
            <>
              <div style={{ fontSize: '10px', color: '#8f8f8f', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>
                {historico.length} agendamento{historico.length !== 1 ? 's' : ''}
              </div>
              {historico.map((a, i) => {
                const statusColor = a.status === 'confirmado' ? '#7bc47b'
                  : a.status === 'cancelado' ? '#e05555' : '#c9a84c';
                const statusBg = a.status === 'confirmado' ? '#1a2a1a'
                  : a.status === 'cancelado' ? '#2a1414' : '#2a2010';
                const statusBorder = a.status === 'confirmado' ? '#2d4a2d'
                  : a.status === 'cancelado' ? '#4a1a1a' : '#4a3a1a';
                const statusLabel = a.status === 'confirmado' ? 'Confirmado'
                  : a.status === 'cancelado' ? 'Cancelado' : 'Pendente';

                return (
                  <div key={a.id} style={{
                    backgroundColor: '#181818', border: '0.5px solid #252525',
                    borderRadius: '12px', padding: '13px 14px',
                    marginBottom: '8px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#e8e8e8' }}>
                        {a.barbearia || '—'}
                      </div>
                      <span style={{
                        fontSize: '10px', fontWeight: '600', color: statusColor,
                        backgroundColor: statusBg, border: `0.5px solid ${statusBorder}`,
                        borderRadius: '20px', padding: '2px 8px'
                      }}>{statusLabel}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#aeaeae', marginBottom: '3px' }}>
                      {a.servico} {a.barbeiro ? `· ${a.barbeiro}` : ''}
                    </div>
                    <div style={{ fontSize: '11px', color: '#8f8f8f' }}>
                      {a.dia} de {a.mes} às {a.horario}
                      {a.preco ? <span style={{ color: '#7bc47b', marginLeft: '8px', fontWeight: '600' }}>{a.preco}</span> : null}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default PerfilCliente;
